export const dateFormat = "MM/DD/YYYY";
export const friendlyDateFormat = "MMM DD, YYYY";
export const friendlyLongDateFormat = "LL";
